// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetFoldersRequest,
  TGetFoldersModel,
  IMappers,
  TGetFoldersResponse,
  IGetFoldersResponse,
  IGetFoldersResponseError,
} from './types';

export const defaultConfig: TGetFoldersModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'favorites',
  pathApi: '/v1/get-folders/',
} as TGetFoldersModel;

export function createGetFoldersModel(parameters: IGetFoldersRequest): TGetFoldersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetFoldersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetFoldersRequest;
}

export async function fetchGetFolders<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetFoldersOptions<TResponse200, TResponse400>): Promise<TGetFoldersResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetFoldersModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFoldersResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetFoldersResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetFoldersResponse;
}
